var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vuestic-modal',{ref:"mediumModal",attrs:{"show.sync":"true","okText":_vm._f("translate")('upgrade.payInvoice'),"cancelText":_vm._f("translate")('modal.cancel')},on:{"ok":_vm.confirm}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.$t('upgrade.existingInvoiceTitle')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('upgrade.existingInvoiceBody')))])])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ef44886","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upgrade/ExistingInvoiceAction.vue
// module id = rjuh
// module chunks = 35